import { useGetCurrentUserQuery } from "@lib/store/slices/user";

export enum LoginStatus {
  LoggedIn = "LoggedIn",
  LoggedOut = "LoggedOut",
  Loading = "Loading",
}

export default function useLoginStatus() {
  const { isError, isLoading } = useGetCurrentUserQuery();

  if (isLoading) {
    return LoginStatus.Loading;
  }
  if (isError) {
    return LoginStatus.LoggedOut;
  }

  return LoginStatus.LoggedIn;
}
